import { render, staticRenderFns } from "./NuevaVacante.vue?vue&type=template&id=66bc7de7&scoped=true"
import script from "./NuevaVacante.vue?vue&type=script&lang=js"
export * from "./NuevaVacante.vue?vue&type=script&lang=js"
import style0 from "./NuevaVacante.vue?vue&type=style&index=0&id=66bc7de7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bc7de7",
  null
  
)

export default component.exports